export default "__VITE_ASSET__B_ETa$aA__"